export default __webpack_public_path__ + "static/media/total.b5d178b2.svg";